import { render, staticRenderFns } from "./withdraw_apply_detail.vue?vue&type=template&id=3faef6f8&scoped=true"
import script from "./withdraw_apply_detail.vue?vue&type=script&lang=js"
export * from "./withdraw_apply_detail.vue?vue&type=script&lang=js"
import style0 from "./withdraw_apply_detail.vue?vue&type=style&index=0&id=3faef6f8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3faef6f8",
  null
  
)

export default component.exports